import React, { useRef } from 'react';
import styled, { css } from 'styled-components';
import { TopBannerListModel } from 'autogen/swagger/all';
import TopBannerItem from 'components/topBanners//topBannerItem';
import { ColorNeutralWhite } from 'autogen/design-tokens/tokens';
import useIsOverflowing from 'hooks/globals/useIsOverflowing';

const TopBannersList = styled.div<{ isOverflowing: boolean }>`
    display: flex;
    padding: 0 12px;
    background: ${ColorNeutralWhite};

    ${({ isOverflowing }) =>
        isOverflowing &&
        css`
            overflow-y: scroll;
            overflow: -moz-scrollbars-none;

            &::-webkit-scrollbar {
                height: 0 !important;
                width: 0 !important;
            }
        `}
`;

export default function SimpleBannerList({ topBanners }: TopBannerListModel): JSX.Element {
    const contentRef = useRef<HTMLDivElement>(null);
    const isOverflowing = useIsOverflowing(contentRef, false);

    return (
        <TopBannersList isOverflowing={isOverflowing} ref={contentRef}>
            {topBanners.map((topBanner) => {
                const props = { singleBanner: true, ...topBanner };
                return <TopBannerItem {...props} key={topBanner.text} />;
            })}
        </TopBannersList>
    );
}
